import { CutlioValidation } from "../../../Cutlio.Common/Validation";

export const LoginValidationSchema = CutlioValidation.object().shape({
  email: CutlioValidation.string().email().required(),
  password: CutlioValidation.string().required().min(6),
});
